import axios from 'axios'

const config = {
  baseURL: 'https://s5wi802bij.execute-api.us-east-1.amazonaws.com/unacem_ecuador/api/v1/',
  // baseURL: 'http://localhost:8000/api/v1/',
  timeout: 30000
}

const Repository = {
  public () {
    return axios.create(config)
  },
  private () {
    config.headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
    return axios.create(config)
  },
  multipart () {
    config.headers = {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
    return axios.create(config)
  },
  baseURL () {
    return config.baseURL
  }
}

export default Repository
